import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectCmsControlByIdByPage } from "../../redux/slices/cmsSettingsSlice";
import StoreHeadingControl from "./StoreHeadingControl";
import ConnectedStorePurchaseRecipient from "../Pages/StorePage/ConnectedStorePurchaseRecipient";

const ConnectedStoreHeadingControl = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_P2P_STORE,
            state,
        ),
    );

    const {
        options: { sectionHeading = "Optional Add-ons", additionalText = "" },
    } = control;

    const renderHeading = () => (
        <>
            <h3>{sectionHeading}</h3>

            {additionalText && <p>{additionalText}</p>}

            <ConnectedStorePurchaseRecipient controlId={controlId} />
        </>
    );

    return <StoreHeadingControl renderHeading={renderHeading} />;
};

ConnectedStoreHeadingControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedStoreHeadingControl;
